import React from 'react';
import { Link } from 'gatsby-plugin-react-i18next';
import useLanguage from '../../../../../hooks/useLanguage';
import PropTypes from 'prop-types';

import Arrow from '../../../../../svg/arr_right_top.svg';
import Star from '../../../../../svg/star_shaddow.svg';

const HomeAboutFooter = ({ openPopup }) => {
  const langToggle = useLanguage;
  return (
    <footer className="home-about__footer">
      <div className="home-about__footer-col">
        <Link to="/about/" className="home-about__footer-link">
          <div className="home-about__footer-link__icon">
            <Star className="about-footer__link-icon__star" />
            <Arrow className="about-footer__link-icon__arrow" />
          </div>
          <span className="about-footer__link__title-wrapper">
            <span className="about-footer__link__title">
              {langToggle('Більше про школу', 'Больше о школе')}
            </span>
          </span>
        </Link>
      </div>
      <div className="home-about__footer-col">
        <button className="home-about__footer-link" onClick={openPopup}>
          <div className="home-about__footer-link__icon">
            <Star className="about-footer__link-icon__star" />
            <Arrow className="about-footer__link-icon__arrow" />
          </div>
          <span className="about-footer__link__title-wrapper">
            <span className="about-footer__link__title">
              {langToggle('Безкоштовне заняття', 'Бесплатный урок')}
            </span>
          </span>
        </button>
      </div>
    </footer>
  );
};

HomeAboutFooter.propTypes = {
  openPopup: PropTypes.func,
};

export default HomeAboutFooter;
